import clsx from 'clsx'
import { useIntl } from 'react-intl'
import { createPortal } from 'react-dom'
import { NavLink, useNavigate } from 'react-router-dom'
import { XCircle } from 'phosphor-react'
import { AnimatePresence, motion } from 'framer-motion'

import { useAuth } from '../contexts/AuthContext'

interface MobileMenuProps {
  isOpen: boolean
  onClose: () => void
  onOpenSkillsMenu: () => void
}

export const ExpertMobileNavigation = ({
  isOpen,
  onClose,
  onOpenSkillsMenu,
}: MobileMenuProps) => {
  const { user, signOut } = useAuth()
  const { formatMessage } = useIntl()
  const navigate = useNavigate()

  const handleSignOut = () => {
    signOut()
    navigate('/expert', {
      replace: true,
    })
  }

  return createPortal(
    <AnimatePresence>
      {isOpen && (
        <motion.div
          key="mobile-menu"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed top-0 bottom-0 left-0 right-0 z-10 flex-col h-full px-8 py-8 overflow-hidden overflow-y-scroll bg-white"
        >
          <header className="mb-14">
            <button onClick={onClose} className="block mb-12 ml-auto">
              <XCircle className="text-2xl" />
            </button>
            <div className="flex items-center gap-4">
              <div>
                <span className="block text-base font-normal">
                  {user?.name}
                </span>
                <span className="text-sm text-grey-700">{user?.email}</span>
              </div>
            </div>
          </header>

          <ul className="flex flex-col flex-1">
            <li className="pb-6">
              <NavLink
                to="/expert/meetings"
                onClick={onClose}
                className={({ isActive }) =>
                  clsx({ 'text-primary-light font-bold': isActive })
                }
              >
                {formatMessage({ id: 'MEETINGS' })}
              </NavLink>
            </li>
            <li className="py-6 border-t border-gray-400">
              <NavLink to="/expert/personal-data" onClick={onClose}>
                {formatMessage({ id: 'PERSONAL_DATA' })}
              </NavLink>
            </li>
            <li className="py-6 border-t border-gray-400">
              <NavLink
                to="/expert/bank-data"
                onClick={onClose}
                className={({ isActive }) =>
                  clsx({ 'text-primary-light font-bold': isActive })
                }
              >
                {formatMessage({ id: 'BANK_DATA' })}
              </NavLink>
            </li>
            <li className="py-6 border-t border-gray-400">
              <NavLink onClick={onClose} to="/expert/skills">
                {formatMessage({ id: 'SKILLS' })}
              </NavLink>
            </li>
            <li className="py-6 border-t border-gray-400">
              <NavLink to="#" onClick={onOpenSkillsMenu}>
                {formatMessage({ id: 'LANGUAGES' })}
              </NavLink>
            </li>
            <li className="py-6 border-t border-gray-400">
              <NavLink to="/expert/term-of-participation" onClick={onClose}>
                {formatMessage({ id: 'TERM_OF_PARTICIPATION' })}
              </NavLink>
            </li>
            <li className="py-6 border-t border-gray-400">
              <NavLink to="/expert/change-password" onClick={onClose}>
                {formatMessage({ id: 'CHANGE_PASSWORD' })}
              </NavLink>
            </li>
          </ul>

          <footer className="flex justify-center mt-12">
            <button
              onClick={handleSignOut}
              className="px-12 py-3 text-sm font-normal border rounded-lg border-grey-500 text-[#4B4B4B]"
            >
              {formatMessage({ id: 'LOGOUT' })}
            </button>
          </footer>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body
  )
}
